var exports = {
  "zr": "AudioWaveform.module__root___ZDMzM2",
  "Ji": "AudioWaveform.module__canvas___ZDMzM2",
  "r1": "AudioWaveform.module__selection___ZDMzM2",
  "EP": "AudioWaveform.module__selectionDragging___ZDMzM2",
  "p$": "AudioWaveform.module__handle___ZDMzM2",
  "p_": "AudioWaveform.module__handleStart___ZDMzM2",
  "es": "AudioWaveform.module__handleEnd___ZDMzM2",
  "lG": "AudioWaveform.module__playhead___ZDMzM2",
};

module.exports = exports;
